
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getAbnormal, getMerchantFundDetails } from '@/api/task/exOrder'
import { notifiedStatus, upStreamStatusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'orderDetail',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any
  private tabName: string = 'attach'
  private abnormalOrders: any = {}
  private notifiedStatus = notifiedStatus
  private orderTypeList = upStreamStatusList
  private transactionList: any[] = []
  private listLoading: Boolean = false

  private async getAbnormal () {
    let data: any = {
      task_id: this.info.id
    }
    try {
      await getAbnormal(data).then(res => {
        this.abnormalOrders = res
      })
    } catch (e) {}
  }

  // 获取商户明细列表
  private async getMerchantDetail () {
    try {
      this.listLoading = true
      const data: any = {
        currency: AppModule.currentCurrencyType,
        id: this.info.event.transaction_id,
        merchant_no: this.info.event.merchant_no,
        action: this.info.event.action,
        order_number: this.info.event.order
      }
      await getMerchantFundDetails(data).then((res: any) => {
        this.transactionList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async init () {
    this.getAbnormal()
    if (
      (this.info.event.transaction_id &&
        this.info.event.transaction_id !== 0) ||
      this.info.event.order
    ) {
      this.getMerchantDetail()
    }
  }

  mounted () {
    this.init()
  }
  created () {}
}
